import React from "react";
import { Check, Pencil, Trash2 } from "lucide-react";
import {
  daysRemainingLabel,
  formatDueDate,
  formatUpdatedAt,
} from "@/lib/status";
import StatusBadge, { StatusDot } from "@/components/StatusBadge";
import DocumentCell from "@/components/DocumentCell";
import { TID } from "@/lib/testIds";
import { cn } from "@/lib/utils";

export default function MobileList({
  rows,
  onToggleComplete,
  onEdit,
  onDelete,
  onUpload,
  onRemoveDoc,
}) {
  return (
    <div className="flex flex-col gap-3">
      {rows.map((task) => (
        <div
          key={task.id}
          className="ab-card ab-shadow-sm p-4 flex flex-col gap-3"
          data-testid={TID.taskRow(task.id)}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-start gap-2 min-w-0">
              <div className="mt-1">
                <StatusDot status={task.derivedStatus} />
              </div>
              <div className="min-w-0">
                <div
                  className="font-medium text-[#0F172A] text-sm leading-snug"
                  data-testid={TID.taskTitle(task.id)}
                >
                  {task.title}
                </div>
                <div className="mt-1 flex items-center gap-2 text-[11px] text-[#64748B]">
                  <span className="bg-[#F1F5F9] rounded px-1.5 py-0.5 text-[#334155] font-medium">
                    {task.category}
                  </span>
                  <span>Due {formatDueDate(task.dueDate)}</span>
                </div>
              </div>
            </div>
            <StatusBadge status={task.derivedStatus} />
          </div>

          <div className="flex items-center justify-between text-xs text-[#64748B]">
            <span className="tabular-nums">{daysRemainingLabel(task)}</span>
            <span className="tabular-nums">
              Updated {formatUpdatedAt(task.updatedAt)}
            </span>
          </div>

          <div className="flex items-center justify-between gap-2">
            <DocumentCell
              task={task}
              onUpload={onUpload}
              onRemove={onRemoveDoc}
            />
            <div className="inline-flex items-center gap-1">
              <button
                type="button"
                onClick={() => onToggleComplete(task)}
                className={cn(
                  "inline-flex items-center gap-1 rounded-md px-2 h-7 text-xs font-medium border",
                  task.status === "Completed"
                    ? "bg-white border-[#E2E8F0] text-[#64748B]"
                    : "bg-[#0F172A] border-[#0F172A] text-white"
                )}
                data-testid={TID.taskToggle(task.id)}
              >
                <Check className="h-3 w-3" />
                {task.status === "Completed" ? "Undo" : "Done"}
              </button>
              <button
                type="button"
                onClick={() => onEdit(task)}
                className="h-7 w-7 inline-flex items-center justify-center rounded-md border border-[#E2E8F0] text-[#334155]"
                data-testid={TID.taskEdit(task.id)}
              >
                <Pencil className="h-3.5 w-3.5" />
              </button>
              <button
                type="button"
                onClick={() => onDelete(task)}
                className="h-7 w-7 inline-flex items-center justify-center rounded-md border border-[#E2E8F0] text-[#334155]"
                data-testid={TID.taskDelete(task.id)}
              >
                <Trash2 className="h-3.5 w-3.5" />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
